import { useDataValue } from 'Simple/Data.js'
import useStableValue from 'Logic/useStableValue.js'
import { formatTzDate } from 'Data/format.js'

/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props) {
  let appointment_type_id = useDataValue({
    context: 'appointment_overlay',
    path: 'appointment_type_id',
    viewPath: props.viewPath,
  })
  let appointment_id = useDataValue({
    context: 'appointment_overlay',
    path: 'appointment_id',
    viewPath: props.viewPath,
  })
  let duration = useDataValue({
    context: 'appointment_overlay',
    path: 'duration',
    viewPath: props.viewPath,
  })
  let location_id = useDataValue({
    context: 'tab',
    path: 'selected.location_id',
    viewPath: props.viewPath,
  })
  let date = useDataValue({
    context: 'tab',
    path: 'selected.date',
    viewPath: props.viewPath,
  })
  let time_zone_id = useDataValue({
    context: 'tab',
    path: 'selected.time_zone_id',
    viewPath: props.viewPath,
  })
  let stableDuration = useStableValue(duration)

  return {
    variables: {
      location_id,
      appointment_type_id,
      start_date: formatTzDate(date, 'yyyy-MM-dd', time_zone_id),
      end_date: formatTzDate(date, 'yyyy-MM-dd', time_zone_id),
      // to ignore when rescheduling
      appointment_id:
        (appointment_id === 'new' ? null : appointment_id) || null,
      duration: stableDuration,
    },
    pause:
      !location_id ||
      !appointment_type_id ||
      !date ||
      !time_zone_id ||
      !stableDuration ||
      stableDuration <= 0,
    requestPolicy: 'network-only',
  }
}
